import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";
import {
  DEFAULT_ITEMS_PER_PAGE,
  SORT_ORDER_DESC,
  LIST_DEF_SORT,
  STATUS,
} from "../../core/constants/common";

export default class InvitationService {
  static getInvitationsList() {
    return HttpUtil.get(API_ROUTES.INVITATIONS.GETLIST);
  }
  static resendInvitation(invitationId, status="INVITED") {
    return HttpUtil.patch(
      API_ROUTES.INVITATIONS.RESENDINVITATION.replace(
        "<invitationId>",
        invitationId
      )
      .replace(
        "<status>",
        status
      )
    );
  }
  static updateCompanyInvitation(params, invitationId) {
    return HttpUtil.put(
      API_ROUTES.INVITATIONS.UPDATEINVITATION.replace(
        "<invitationId>",
        invitationId
      ),
      params
    );
  }
  static getPendingInvitations( pageNumber = 0,
    pageSize = DEFAULT_ITEMS_PER_PAGE,
    sort,) {
    return HttpUtil.get(API_ROUTES.INVITATIONS.PENDINGINVITATIONS.replace("<pageNumber>", pageNumber)
    .replace("<pageSize>", pageSize)
    .replace("<sort>", sort));
  }
  static updateInvitationStatus(invitationId, status) {
    return HttpUtil.patch(
      API_ROUTES.INVITATIONS.RESENDINVITATION.replace(
        "<invitationId>",
        invitationId
      )
      .replace(
        "<status>",
        status
      )
    );
  }
  static verifyInvitation(key) {
    return HttpUtil.uniterceptedGet(API_ROUTES.SETPWD.INVITATIONVERIFY+`/${key}/verify`);
  }

  static getInvitationById(invitationId) {
    return HttpUtil.get(API_ROUTES.INVITATIONS.GETINVITATIONBY_ID.replace("<invitationId>", invitationId));
  }
}
